/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeProfileAddressesId = 'route-profile-addresses-id',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang).profile.addresses.$id',
	profileAddresses = 'routes/($lang).profile.addresses',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as PROFILE_ADDRESSES_ID_I18NEXT,
	ROUTE_LOADER as PROFILE_ADDRESSES_ID_ROUTE_LOADER,
}
